// import { useEffect, useState } from 'react';
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";

function EliteRecruitment() {
  // const [ articleContent, setArticleContent ] = useState([]);
  // const [ sliderContent, setSliderContent ] = useState([]);
  // const [ selectedCardIndex, setSelectedCardIndex ] = useState(0);

  // useEffect(() => {
  //   let pageType = 0;
  //   let id = 7;
  //   fetch(`/api/homepage/pageResource/${pageType}/${id}`)
  //     .then(response => {
  //       if (!response.ok) {
  //         throw new Error('Network response was not ok');
  //       }
  //       return response.json();
  //     })
  //     .then(data => {
  //         const pageData = data.data.article[0].article[0];
  //         setArticleContent([pageData]);
  //         const sliderData = data.data.slider;
  //         setSliderContent(sliderData);
  //     })
  //     .catch(error => console.error('Error fetching article content:', error));
  // }, []);

  return (
    <>
      <Navbar />
      <main className="pb-[166px]">
        <section className="h-[250px] m-auto pt-[90px] page-title">
          <div className="text-center mb-[44px]">
            <h2 className="text-[#3D3D3D] font-normal text-5xl mb-[15px]">菁英招募</h2>
            <h3 className="text-[#696969] font-normal text-xl" style={{ color: "#ff6b2b" }}>
              Elite Recruitment
            </h3>
          </div>
        </section>
        <section className="max-w-[980px] m-auto pt-[70px] md-l:mx-10">
          <img src="/recruitment.jpg" alt="" />
          <div className="pt-[70px] leading-loose">
            <p>菁英招募中！期待您的加入</p>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default EliteRecruitment;
